import { Component, Input, OnInit } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { Facet, FacetNode } from "../../../../models/facet.model"
import { BaseNode } from "../../../../models/node.model"
import { FacetingService } from "../../../../services/faceting.service"
import { fadeInXY, rotateRight } from "../../../../utils/animations"

@Component({
    selector: "app-nested-facet-nodes",
    templateUrl: "./nested-facet-nodes.component.html",
    styleUrls: ["./nested-facet-nodes.component.scss"],
    animations: [fadeInXY, rotateRight],
    standalone: false,
})
export class NestedFacetNodesComponent implements OnInit {
    @Input() public facet: Facet<BaseNode>
    @Input() public facetNode: FacetNode
    public children: FacetNode[] = []

    constructor(
        private facetingService: FacetingService,
        private route: ActivatedRoute
    ) {}

    public ngOnInit() {
        this.children = this.facet.childrenOf(this.facetNode.facetId)
    }

    public onToggleClick(facetNode: FacetNode) {
        facetNode.expanded = !facetNode.expanded
    }

    public onCheckboxChange(event, facetNode: FacetNode) {
        const currentFilter = `${facetNode.node.type}:${facetNode.node.id}`
        if (event.target.checked) {
            facetNode.expanded = true
            this.facetingService.addFilter(currentFilter, this.route)
        } else {
            this.facetingService.removeFilter(currentFilter, this.route)
        }
    }
}
